var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedln(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28207 8.72097H6.25467C4.88471 8.72097 3.99652 7.82468 3.99652 6.68856C3.99652 5.53034 4.91097 4.65283 6.30833 4.65283C7.70454 4.65283 8.56305 5.52813 8.59045 6.68524C8.59045 7.82136 7.70454 8.72097 6.28207 8.72097ZM23.4185 21.9119H19.1271V15.8445C19.1271 14.2564 18.4558 13.1722 16.9797 13.1722C15.8506 13.1722 15.2227 13.9038 14.9305 14.6089C14.834 14.8318 14.8357 15.1317 14.8375 15.4409C14.8377 15.4828 14.838 15.525 14.838 15.5671V21.9119H10.5865C10.5865 21.9119 10.6413 11.1641 10.5865 10.1871H14.838V12.0272C15.0892 11.2227 16.4477 10.0744 18.6157 10.0744C21.3054 10.0744 23.4185 11.7609 23.4185 15.3925V21.9119ZM8.26962 10.1866H4.4851V21.9114H8.26962V10.1866Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedln);
export default __webpack_public_path__ + "static/media/linkedln.8e945e97aa2764f8bf674e38c47556de.svg";
export { ForwardRef as ReactComponent };